import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { API } from 'aws-amplify';
import awsconfig from './aws-exports';
import * as VeeValidate from 'vee-validate'
import './vee-validate'
import { ValidationObserver, ValidationProvider} from 'vee-validate';

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

Vue.use(VeeValidate);

Vue.config.productionTip = false;
API.configure(awsconfig);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')


